// extracted by mini-css-extract-plugin
export var dropdownButton = "_3b-0";
export var fullWidthDropdownButton = "_3b-1";
export var icon = "_3b-3";
export var iconPlaceholder = "_3b-2";
export var menuItemRow = "_3b-9";
export var separator = "_3b-e";
export var shortcutContainer = "_3b-7";
export var shortcutContainerFilled = "_3b-8";
export var shortcutIconLg = "_3b-6";
export var shortcutIconMd = "_3b-5";
export var shortcutIconSm = "_3b-4";
export var submenuChevron = "_3b-d";
export var submenuDropdown = "_3b-a";
export var submenuTriggerRow = "_3b-b";
export var submenuTriggerRowOpen = "_3b-c";